import { Modal } from "@stellar/design-system";

interface TemplateInstructionsModalProps {
  visible: boolean;
  onClose: () => void;
}

export const TemplateInstructionsModal = ({ visible, onClose }: TemplateInstructionsModalProps) => (
  <Modal visible={visible} onClose={onClose}>
    <Modal.Heading>Template instructions</Modal.Heading>
    <Modal.Body>
      <p>
        Upload a <strong>.CSV</strong> file using the column headers and formats from the CSV
        template. The column names are case-sensitive.
      </p>

      <div className="TemplateInstructionsModal__section">
        <h4>Required fields</h4>
        <ul>
          <li>
            <strong>phone</strong> or <strong>email</strong>: The recipient&apos;s phone number or
            email address. Only one is required per recipient. Phone numbers must include the
            country code (e.g., +50937123456).
          </li>
          <li>
            <strong>walletAddress</strong> (only when sending via wallet address): The Stellar
            blockchain address of the recipient.
          </li>
          <li>
            <strong>id</strong>: A unique reference number for each recipient in your system (e.g.,
            00123).
          </li>
          <li>
            <strong>amount</strong>: The total amount you are sending to this recipient in the
            selected asset.
          </li>
          <li>
            <strong>verification</strong>: The value used to confirm the recipient&apos;s identity.
            The format must match the verification type chosen in the previous step:
            <ul>
              <li>
                <strong>Full Date of Birth:</strong> YYYY-MM-DD
              </li>
              <li>
                <strong>Year and Month only:</strong> YYYY-MM
              </li>
              <li>
                <strong>National ID:</strong> the recipient&apos;s unique ID number
              </li>
              <li>
                <strong>Code:</strong> 4–8 characters (case-sensitive letters or numbers)
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div className="TemplateInstructionsModal__section">
        <h4>Optional fields</h4>
        <ul>
          <li>
            <strong>paymentID</strong>: An identifier to track this specific transaction in your own
            system.
          </li>
          <li>
            <strong>walletAddressMemo</strong>: When required, the Stellar transaction memo to be
            included alongside the address.
          </li>
        </ul>
      </div>
    </Modal.Body>
  </Modal>
);
